import Container from "@components/Container/Container";

/**
 * Component to render Description of SCA on homepage
 */
const SCADescription = (): React.ReactElement => {
  return (
    <Container
      rootClassName="flex flex-row justify-center px-0"
      data-testid="sca-description-component"
    >
      <div className="mb-6 flex w-full flex-col justify-center pl-3 text-center text-gray-850 md:pl-4 lg:w-11/12 lg:flex-row">
        <div className="w-full lg:w-4/12 lg:pr-4">
          <h2 className="mb-6 text-left font-poppins text-4xl font-medium md:mb-2 md:mb-6 md:text-6xl lg:mb-0 lg:pl-3 lg:text-8xl lg:leading-tight">
            {"Singapore "}
            <br className="hidden lg:inline" />
            {"Corporate "}
            <br className="hidden lg:inline" />
            {"Awards "}
          </h2>
        </div>

        <div className="w-full text-left lg:w-8/12">
          <p className="text-md pl-0 font-public-sans leading-6">
            The Singapore Corporate Awards was launched on 19 September 2005 as
            the umbrella awards for exemplary corporate governance practices for
            listed companies in Singapore. It seeks to consolidate existing
            awards while introducing new awards in the area of excellent
            corporate governance.
          </p>
          <p>
            Since its inauguration in 2005, SCA has been the premier platform
            for awards that recognise exemplary corporate governance practices
            in Singapore&apos;s listed companies. In a year that has seen
            companies re-assess and reinvent themselves, the SCA team is
            committed to continuing the spirit embodied in this event, and will
            throw the spotlight on how good governance plays a fundamental role
            in underpinning corporate excellence.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default SCADescription;
